import { IONICWrapper } from "./common";
import { LATE_REASONCODE_MODAL_CONFIG } from "./AllInterface";
import { DefaultPODrayContactFallback, addReferenceModal, LATE_REASONCODE_MODAL_CONFIG_FALLBACK, CARRIER_TENDERED_LOAD_BUTTON_FALLBACK, START_LOCATION_AND_TIME } from "./constants";

export const isCarrierProVisible = (
  SourceTMS: string,
  division: string
): boolean => {
  const data =
    IONICWrapper?.details?.keys?.configuration?.carrierProVisibilityConfig;
  return data && !!data[SourceTMS]?.["divisions"]?.includes(division);
};

export const isInvoiceInputFieldVisible = (
  SourceTMS: string,
  division: string
): boolean => {
  const data =
    IONICWrapper?.details?.keys?.configuration?.createInvoiceInputFieldVisibilityConfig;
  return data && !!data[SourceTMS]?.["divisions"]?.includes(division);
};

export const loadTileButtonVisibility = (
  SourceTMS: string,
  division: string,
  type: string
): boolean => {
  const data = IONICWrapper?.details?.keys?.configuration?.carrierTendered || CARRIER_TENDERED_LOAD_BUTTON_FALLBACK;
  return data && !!data?.[SourceTMS]?.[type]?.includes(division);
};

export const declineReasonCodesVisibility = (
  SourceTMS: string,
  division: string
): object[] => {
  const data = IONICWrapper?.details?.keys?.configuration?.carrierTendered || CARRIER_TENDERED_LOAD_BUTTON_FALLBACK;
  return data && data?.[SourceTMS]?.REASON_CODES?.[division];
};

export const isAddReferencesVisible = (
  SourceTMS: string,
  division: string
): boolean => {
  const data = IONICWrapper?.details?.keys?.configuration?.addReferenceModal;
  return data
    ? !!data?.[SourceTMS]?.["visible"]?.hasOwnProperty(division)
    : addReferenceModal[0]?.[SourceTMS]?.["visible"]?.hasOwnProperty(division);
};

export const referencesDropdownButtons = (
  SourceTMS: string,
  division: string
): string[] => {
  const data = IONICWrapper?.details?.keys?.configuration?.addReferenceModal;
  return data
    ? data?.[SourceTMS]?.["visible"][division]?.["references"]
    : addReferenceModal[0]?.[SourceTMS]?.["visible"][division]?.["references"];
};

export const lateReasonCodeModalVisibility = (
  SourceTMS: string,
  division: string,
  gracePeriodinMinutes: string,
  gracePeriodinHours: string
): boolean => {
  const data: LATE_REASONCODE_MODAL_CONFIG =
    IONICWrapper?.details?.keys?.configuration?.lateReasonCodeModal ||
    LATE_REASONCODE_MODAL_CONFIG_FALLBACK;
  const response: boolean =
    data &&
    !!data?.[SourceTMS]?.["VISIBILITY"]?.includes(division) &&
    !!(gracePeriodinHours!== "00"? true : data?.[SourceTMS]?.["GRACE_PERIOD"]?.[division] <= gracePeriodinMinutes);
  return response;
};

export const lateReasonCodeModalDropDownValues = (
  SourceTMS: string,
  division: string
): any => {
  const data: LATE_REASONCODE_MODAL_CONFIG =
    IONICWrapper?.details?.keys?.configuration?.lateReasonCodeModal ||
    LATE_REASONCODE_MODAL_CONFIG_FALLBACK;
  const dropDownValues =
    data && data?.[SourceTMS]?.["REASON_CODES"]?.[division];
  return dropDownValues;
};

export const carrierProInputBoxVisibility = (
  SourceTMS: string,
  division: string,
  type: string
): boolean => {
  const data : any = IONICWrapper?.details?.keys?.configuration?.carrierTendered || CARRIER_TENDERED_LOAD_BUTTON_FALLBACK;
  return data && !!data?.[SourceTMS]?.[type]?.includes(division);
};

export const declineReasonDropDownVisibility = (
  SourceTMS: string,
  division: string,
  type: string
): boolean => {
  const data: any = IONICWrapper?.details?.keys?.configuration?.carrierTendered || CARRIER_TENDERED_LOAD_BUTTON_FALLBACK;
  let isDeclineReasonDropDown: boolean = false
  if (data?.[SourceTMS]?.[type]?.hasOwnProperty(division)) {
    Object.keys(data && data?.[SourceTMS]?.[type][division])?.map((obj: any) => {
      if (obj.length > 0) {
        isDeclineReasonDropDown = true
      }
    })
  }
  return isDeclineReasonDropDown;
};

export const startLocationAndTimeVisibility = (
  SourceTMS: string,
  division: string,
  locationName: string | any,
  startDate: any
): any => {
  const inputValue: any = IONICWrapper?.details?.keys?.configuration?.startLocationAndTime || START_LOCATION_AND_TIME;
  if (inputValue?.[SourceTMS]?.["DEFAULT"]?.includes(division)) {
    return startDate ? startDate : locationName;
  }
  else if (inputValue?.[SourceTMS]?.["EMPTY"]?.includes(division)) {
    return startDate ? null : "";
  } else {
    return startDate ? null : "";
  }
};